<script setup lang="ts">
import PopularProductsSection from '@/pages/home/ui/popularProductsSection/index.vue';
import { ProductsSlider } from '@/widgets/productsSlider/index';
import UIBanner from '@/shared/ui/Banner';

const isMobile = inject('isMobile');
const { t } = useI18n();
const localePath = useLocalePath();

const {
  public: { platform },
} = useRuntimeConfig();

const BannerSlider = defineAsyncComponent(
  () => import(`@/pages/home/ui/bannerSliderSection/${platform}/BannerSlider.vue`),
);

useHead({
  title: 'Resursi Distribution',
  meta: [{ name: 'description', content: 'Resursi Distribution' }],
});
</script>

<template>
  <div :class="['main-page', { _mobile: isMobile }]">
    <section class="main-page__item">
      <component :is="BannerSlider" />
    </section>
    <section class="main-page__item">
      <PopularProductsSection />
    </section>
    <section class="main-page__item">
      <ProductsSlider
        :title="t('new_arrival')"
        :query-params="{ new_arrival: true, page_size: 8 }"
        :link="localePath('new')"
        :products-key="'products-slider-new'"
      />
    </section>
    <section class="main-page__item _banner-first">
      <UIBanner
        :title="`${t('yourSweetWorld')} <br /> ${t('exquisiteFlavors')}`"
        :images="{
          desktop: '/images/banners/home/choco-banner.png',
          mobile: '/images/banners/home/choco-banner-mobile.png',
        }"
        :button-text="t('more')"
        is-hide-line-break
      />
    </section>
    <section class="main-page__item">
      <ProductsSlider
        :title="t('onSale')"
        :query-params="{ sale: true, page_size: 8 }"
        :link="localePath('sale')"
        :products-key="'products-slider-sale'"
      />
    </section>
    <section class="main-page__item">
      <ProductsSlider
        :title="t('liquidation')"
        :query-params="{ liquidation: true, page_size: 8 }"
        :link="localePath('liquidation')"
        :products-key="'products-slider-liquidation'"
      />
    </section>
    <section class="main-page__item _banner-second">
      <UIBanner
        :title="`${t('becomeOurPartner')} <br /> ${t('growTogether')}`"
        :description="`${t('joinOurPartnerProgram')} <br /> ${t('getExclusiveConditions')}`"
        :images="{
          desktop: '/images/banners/home/partners-banner.png',
          mobile: '/images/banners/home/partners-banner-mobile.png',
        }"
        :button-text="t('more')"
        :to="localePath('for-business')"
        is-hide-line-break
      />
    </section>
  </div>
</template>

<style lang="less">
.main-page {
  .flex-column(@size-x10);

  margin-top: @size-x4;

  &__item {
    &._banner-first,
    &._banner-second {
      .container-d();
    }

    &._banner-first {
      height: 250px;
    }

    &._banner-second {
      height: 350px;
      margin-bottom: 48px;
    }
  }

  &._mobile {
    gap: @size-x6;

    .main-page__item {
      &._banner-first,
      &._banner-second {
        .container-m();
      }

      &._banner-first {
        height: 270px;
      }

      &._banner-second {
        height: 311px;
        margin-bottom: @size-x8;
      }
    }
  }
}
</style>
